export const monitorQrcodesConstants = {
  GETMONITOR_QRCODES_REQUEST: 'GETMONITOR_QRCODES_REQUEST',
  GETMONITOR_QRCODES_SUCCESS: 'GETMONITOR_QRCODES_SUCCESS',
  GETMONITOR_QRCODES_FAILURE: 'GETMONITOR_QRCODES_FAILURE',
};
